var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 53,
    viewBox: "0 0 52 53",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26.5,
    r: 26,
    fill: "#38879F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.125 17.666V14.541H19.2083V17.666H22.3333V19.7493H19.2083V22.8743H17.125V19.7493H14V17.666M20.25 23.916V20.791H23.375V17.666H30.6667L32.5417 19.7493H35.875C37.0208 19.7493 37.9583 20.6868 37.9583 21.8327V34.3327C37.9583 35.4785 37.0208 36.416 35.875 36.416H19.2083C18.0625 36.416 17.125 35.4785 17.125 34.3327V23.916M27.5417 33.291C32.1771 33.291 34.5104 27.6868 31.2292 24.3952C27.9479 21.1139 22.3333 23.4473 22.3333 28.0827C22.3333 30.9577 24.6667 33.291 27.5417 33.291ZM24.2083 28.0827C24.2083 31.0514 27.8021 32.541 29.8958 30.4368C32 28.3431 30.5104 24.7493 27.5417 24.7493C25.7083 24.7493 24.2083 26.2493 24.2083 28.0827Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.f2d5200f0eccc9397d79702019a476b8.svg";
export { ForwardRef as ReactComponent };